<div class="notification" [class.notification--app-update]="notification.type === 'appUpdate'">
  @if (notification.type === 'appUpdate') {
    <div class="type"><fa-icon [icon]="faArrowsRotate"></fa-icon></div>
    <div class="content">
      <div class="description">
        @if (notification.version; as version) {
          {{ 'Version [version] is available.' | translate: { version } }}
        } @else {
          {{ 'A new version is available.' | translate }}
        }
      </div>
      <p class="update-hint">{{ 'Reload after your meeting to update.' | translate }}</p>
      <a [href]="patchNotesUrl" target="_blank" rel="noopener noreferrer">
        {{ 'Patch notes' | translate }}
      </a>
      <div class="date">{{ notification.date | localizedDate: 'short' }}</div>
    </div>
    <andor-icon-btn [aria-label]="'Dismiss update notification' | translate" (click)="dismiss()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </andor-icon-btn>
  }
  @if (notification.type === 'trial') {
    <div class="type">
      <fa-icon [class.error]="trial.expired()" [icon]="faHourglassHalf"></fa-icon>
    </div>
    <div class="content">
      <div class="description" role="status">{{ trial.notice() }}</div>
    </div>
  }
  @if (notification.type === 'joinRequest') {
    <div class="type"><fa-icon class="info" [icon]="faUserPlus"></fa-icon></div>
    <div class="content">
      <div class="description">{{ notification.descriptionShort }}</div>
      <div class="date">{{ notification.date | localizedDate: 'short' }}</div>
    </div>
    <andor-icon-btn
      [attr.inert]="maintenance.active() ? '' : null"
      [attr.aria-disabled]="maintenance.active()"
      (click)="accept(false)">
      <fa-icon class="error" [icon]="faXmark"></fa-icon>
    </andor-icon-btn>
    <andor-icon-btn
      [attr.inert]="maintenance.active() ? '' : null"
      [attr.aria-disabled]="maintenance.active()"
      (click)="accept(true)">
      <fa-icon class="success" [icon]="faCheck"></fa-icon>
    </andor-icon-btn>
  }
  @if (notification.type === 'joinRequestResolved' || notification.type === 'maintenance') {
    <div class="type"><fa-icon class="info" [icon]="faUserPlus"></fa-icon></div>
    <div class="content">
      <div class="description">{{ notification.descriptionShort }}</div>
      <div class="date">{{ notification.date | localizedDate: 'short' }}</div>
    </div>
    <andor-icon-btn (click)="dismiss()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </andor-icon-btn>
  }
  @if (notification.type === 'talkPermissionRequest') {
    <div class="type"><fa-icon class="info" [icon]="faMicrophone"></fa-icon></div>
    <div class="content">
      <div class="description">{{ notification.descriptionShort }}</div>
      <div class="date">{{ notification.date | localizedDate: 'short' }}</div>
    </div>
    <andor-icon-btn (click)="reject(true)">
      <fa-icon class="error" [icon]="faXmark"></fa-icon>
    </andor-icon-btn>
    <andor-icon-btn (click)="accept(true)">
      <fa-icon class="success" [icon]="faCheck"></fa-icon>
    </andor-icon-btn>
  }
  @if (notification.type === 'talkPermissionResponse') {
    <div class="type"><fa-icon class="success" [icon]="faMicrophone"></fa-icon></div>
    <div class="content">
      <div class="description">{{ notification.descriptionShort }}</div>
      <div class="date">{{ notification.date | localizedDate: 'short' }}</div>
    </div>
    <andor-icon-btn (click)="reject(true)">
      <fa-icon class="error" [icon]="faXmark"></fa-icon>
    </andor-icon-btn>
    <andor-icon-btn (click)="accept(true)">
      <fa-icon class="success" [icon]="faCheck"></fa-icon>
    </andor-icon-btn>
  }
</div>
